export const getters = {
  systemSuppliers: state => state.suppliers,
  Supplier: state => state.systemSupplier
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/suppliers/getters.js